import React, { Component } from 'react'
import {Text} from 'components/tt-forms/common';
import moment from 'moment'

export default class ThongTinKeHoachThanhTra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quyetDinhPheDuyet: '',
      ngayBanHanh: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      let dataInfo = nextProps.data;
      this.setState({
        quyetDinhPheDuyet: dataInfo.quyetDinhPheDuyetKTTT,
        ngayBanHanh: dataInfo.ngayRaQuyetDinh ? moment(dataInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
      });
    }
  }

  render() {
    return (
      <div className="box-items mb0">
        <div className="box-forward">
          <div className="title">
            <div className="rows">
              <div className="col-12">
                <h3 className="mb15 tt-title">1. Thông tin kế hoạch {this.props.loaiCuocText}</h3>
              </div>
            </div>
          </div>
          <div className="group-box">
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Quyết định phê duyệt ${this.props.keHoachText}:`} className='col-20' value={this.state.quyetDinhPheDuyet}/>
                <Text label='Ngày Ban Hành:' className='col-20' value={this.state.ngayBanHanh}/>
               </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/ThongTinKeHoachThanhTra.jsx